export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

// _actionTypes.js
export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";
export const CLEAR_AUTH_STATE = "CLEAR_AUTH_STATE";

export const CLEAR_ERROR = 'CLEAR_ERROR';
export const REDIRECT = 'REDIRECT';
export const CHECK_AUTH = 'CHECK_AUTH';
export const CHECK_AUTH_START = 'CHECK_AUTH_START';
export const CHECK_AUTH_SUCCESS = 'CHECK_AUTH_SUCCESS';
export const CHECK_AUTH_FAILURE = 'CHECK_AUTH_FAILURE';
export const SET_INITIAL_CHECK_DONE = 'SET_INITIAL_CHECK_DONE';